import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sessione-milano',
  templateUrl: './sessione-milano.component.html',
  styleUrls: ['./sessione-milano.component.css']
})
export class SessioneMilanoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
